import { isFunction } from 'lodash';

import { TranslatableText } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';
import { PatientId } from '../../../PrescriptionIssuingPanel.types';
import { DraftPrescriptionsFieldArray } from '../DraftPrescriptionsForm.types';

import { PatientEntitlementsDocumentTabs } from './PatientEntitlementsDocumentTabs';
import { useEntitlementsRequiredDocumentMissing } from './PatientEntitlementsEventInterceptor.hooks';
import { PatientEntitlementsChildren } from './PatientEntitlementsEventInterceptor.types';

type PatientEntitlementsEventInterceptorProps = {
   readonly draftPrescriptions: DraftPrescriptionsFieldArray;
   readonly patientId: PatientId;
   readonly children: PatientEntitlementsChildren;
   readonly confirmationButtonLabel?: TranslatableText;
};

export const PatientEntitlementsEventInterceptor = (props: PatientEntitlementsEventInterceptorProps): JSX.Element => {
   const entitlementsRequiredDocumentMissing = useEntitlementsRequiredDocumentMissing(props.draftPrescriptions);
   const documentsMissingCount = entitlementsRequiredDocumentMissing?.length ?? 0;

   return (
      <ShowModalEventInterceptor
         title={draftPrescriptionsTranslationKeys.additionalEntitlementDocuments}
         content={({ resolve, reject }): JSX.Element => {
            return (
               <PatientEntitlementsDocumentTabs
                  entitlementsRequiredDocumentMissing={entitlementsRequiredDocumentMissing}
                  patientId={props.patientId}
                  confirmationButtonLabel={props.confirmationButtonLabel}
                  onAllEntitlementsRequiredDocumentMissingProvided={resolve}
                  onCancel={reject}
               />
            );
         }}
         shouldShowModal={Boolean(documentsMissingCount)}
         modalWidth={ModalWidth.WIDE}
         testId={'patientEntitlements'}
         footerItemsHidden
      >
         {isFunction(props.children) ? props.children(documentsMissingCount) : props.children}
      </ShowModalEventInterceptor>
   );
};
